"use strict";

var curryN = require('../function/curryN');
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @param {String} prop The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 *
 * @example
 *
 *      prop('x', {x: 100}); //=> 100
 *      prop('x', {}); //=> undefined
 */
module.exports = curryN(2, function (prop, obj) {
  return obj != null ? obj[prop] : undefined;
});